import React from 'react'
import './About.css'
import { Link, useNavigate} from 'react-router-dom';

function About({setAbout}) {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
    setAbout(false);
  } 
  const downloadResume = () => {
    window.open(process.env.PUBLIC_URL + '/riya_sachdeva_resume.pdf', '_blank');
  }

  return (
    <div className="postcard about" style={{margin: '0px', filter: 'none'}}>
      <button onClick={handleClose}>Close</button>
      <br></br>
      <div className="receiver absolute" style={{'display': 'inline'}}>
        <label htmlFor="r-name" >To: </label>
        <input disabled={true} type="text" name="receiver-name" placeholder="You"/>
      </div>
      <form>
        
      <div className="sender absolute" style={{'display': 'inline'}}>
        <label htmlFor="s-name" >From: </label>
        <input disabled={true} type="text" name="receiver-name" placeholder="riyasachdeva04"/>
      </div>
      <div className="reply absolute" style={{'display': 'inline'}}>
        <label htmlFor="t-reply" >Reply: </label>
        <input disabled={true} type="text" name="receiver-name" placeholder="sachdevar919@gmail.com"/>
      </div>
      
      <div className="message absolute" style={{'display': 'inline'}}>
        <label htmlFor="t-message" >Your message: </label>
        <br></br>
        <p style={{'maxWidth': '47%', 'fontSize': '19px'}}>Hello! I'm Riya, a machine learning enthusiast, excited about collaborating with diverse technologies. While my main focus is on machine learning, I also have a keen interest in exploring and contributing to AR and Web3. Currently, I'm a sophomore studying Computer Engineering.
        <br></br><br></br>Beyond coding, I find joy in discovering new music and culinary experiences. I also take pleasure in reading poetry. If any of these resonate with you, let's connect! :)</p>
      </div>
      </form>
      <div className="send-btn absolute">
        <button disabled={false} type="button" onClick={downloadResume} name="button"><Link to="/">Checkout my Resume!</Link></button>
      </div>
    </div>
  )
}

export default About
